export default "__VITE_ASSET__2$$TYqzA__"